import React, { Component } from "react";
import "./App.css";
import ArjunCard from "./ArjunCard";
import ArjunCard2 from "./ArjunCard2";
import ArjunCard3 from "./ArjunCard3";
import ArjunCard4 from "./ArjunCard4";
import ArjunCard5 from "./ArjunCard5";
import ReactGA from 'react-ga';




// function initializeReactGA() {
//   ReactGA.initialize('UA-145898279-1');
//   ReactGA.pageview('/homepage');
// }

const trackingId= "UA-145898279-1";
ReactGA.initialize(trackingId);
ReactGA.pageview(window.location.pathname + window.location.search);

class Arjun extends Component {
  constructor() {
    super();

    this.state = {
      value: ""
    };
  }
  onChangeValue = event => {
    this.setState({ value: event.target.value });
  };
 

  render() {
    return (
      
     
      <div className="tc">
        <h1> TAARKIK</h1>
        <input
          type="text"
          placeholder="Enter your name"
          value={this.state.value}
          onChange={this.onChangeValue}
        />
        <br />
        <ArjunCard name={this.state.value} />
        <ArjunCard2 name={this.state.value} />
        <ArjunCard3 name={this.state.value} />
        <ArjunCard4 name={this.state.value} />
        <ArjunCard5 name={this.state.value} />
        <h1>your future versions </h1>
      </div>
    );
  }
}

export default Arjun;
